import { render, staticRenderFns } from "./checkAdd.vue?vue&type=template&id=235088ce&scoped=true&"
import script from "./checkAdd.vue?vue&type=script&lang=js&"
export * from "./checkAdd.vue?vue&type=script&lang=js&"
import style0 from "./checkAdd.vue?vue&type=style&index=0&id=235088ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235088ce",
  null
  
)

export default component.exports